import { render, staticRenderFns } from "./exportSuccessPage.vue?vue&type=template&id=90bf28ea&scoped=true"
import script from "./exportSuccessPage.vue?vue&type=script&lang=js"
export * from "./exportSuccessPage.vue?vue&type=script&lang=js"
import style0 from "./exportSuccessPage.vue?vue&type=style&index=0&id=90bf28ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90bf28ea",
  null
  
)

export default component.exports